import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, radii, space } = theme

export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['spacing-xs']};
`

export const Bar = styled.span<{ $barColor?: string }>`
  display: inline-block;
  flex-shrink: 0;
  width: 0.1875rem;
  height: 0.9rem;
  background-color: ${({ $barColor }) => $barColor ?? colors['blue-background-strong-default']};
  border-radius: ${radii['corner-radius-sm']} 0 0 ${radii['corner-radius-sm']};
`
